const internalReports = [
  {
    tabName: "Abnormality",
    page: [
      {
        name: "Abnormal Offline Payment",
        path: "/internal-reports/abnormal-offline-payment",
        authority: "PORTAL",
        rolePermission: "DATA_INTERNAL_REPORTS",
      },
      {
        name: "Abnormal Online Order",
        path: "/internal-reports/abnormal-online-order",
        authority: "PORTAL",
        rolePermission: "DATA_INTERNAL_REPORTS",
      },
      {
        name: "Abnormal Agent Name",
        path: "/internal-reports/abnormal-agent-name",
        authority: "PORTAL",
        rolePermission: "DATA_INTERNAL_REPORTS",
      },
      {
        name: "Abnormal BR Number",
        path: "/internal-reports/abnormal-br-number",
        authority: "PORTAL",
        rolePermission: "DATA_INTERNAL_REPORTS",
      },
      {
        name: "Abnormal Create Date",
        path: "/internal-reports/abnormal-create-date",
        authority: "PORTAL",
        rolePermission: "DATA_INTERNAL_REPORTS",
      },
      {
        name: "Abnormal Merchant Legal Name",
        path: "/internal-reports/abnormal-merchant-legal-name",
        authority: "PORTAL",
        rolePermission: "DATA_INTERNAL_REPORTS",
      },
      {
        name: "Abnormal Order Transaction Time",
        path: "/internal-reports/abnormal-order-trans-time",
        authority: "PORTAL",
        rolePermission: "DATA_INTERNAL_REPORTS",
      },
      {
        name: "Abnormal Settlement Merchant MDR",
        path: "/internal-reports/abnormal-settlement-merchant-mdr",
        authority: "PORTAL",
        rolePermission: "DATA_INTERNAL_REPORTS",
      },
    ],
  },
];

export default internalReports;
